<template>
    <div class="elseActive">
        <div class="elseActive-main">
            <div class="elseActive-nav">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">活动</el-breadcrumb-item>
                    <el-breadcrumb-item class="special-active">其他活动</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-divider></el-divider>

            <div class="winning-project">其他活动</div>

            <div class="elseActive-nav">
                <time-inquire :typeName='typeName'
                  @updateList="refreshElseActiveData"
                  @changeStartTime="UpdateStartTime"
                  @changeEndTime="UpdateEndTime">
                </time-inquire>
                <content-inquire @resetData="resetElseActiveList" @referData="keyWordRefer"></content-inquire>
                <el-divider></el-divider>

                <div>
                    <p class="content-num">当前共{{totalNum}}条</p>
                    <information-content :infomationContent='elseActiveContent'
                        :goDetailPath='detailPath'
                        :pageType="typeName">
                    </information-content>
                </div>
            </div>

            <paging :totalPage="totalNum"
              :pageSize="size"
              :CurrentPage="page"
              @curentPage="handleCurrentChange">
            </paging>
            <return-top></return-top>
        </div>
    </div>
</template>

<script>
import TimeInquire from '@/components/information/timeInquire.vue'
import ContentInquire from '@/components/information/contentInquire.vue'
import InformationContent from '@/components/information/information-content.vue'
import Paging from '@/components/paging.vue'
import ReturnTop from '@/components/returnTop.vue'
import mixinFun from '@/utils/mixin'
export default {
  name: 'elseActive',
  mixins: [mixinFun],
  props: {

  },
  components: {
    TimeInquire,
    ContentInquire,
    InformationContent,
    Paging,
    ReturnTop

  },
  data () {
    return {
      typeName: 'elseActive',
      detailPath: '/informationDetail',
      elseActiveContent: [],
      totalNum: 0, // 总数据条数
      keyWord: null, // 搜索关键字
      page: 1, // 默认页码
      size: 10, // 每页数据条数
      startTime: null, // 开始时间
      endTime: null // 结束时间
    }
  },
  computed: {

  },
  created () {
    this.getElseActiveData()
  },
  mounted () {
    this.$parent.activeIndex = '4'
  },
  methods: {
    // 获取其他活动数据
    async getElseActiveData () {
      try {
        const res = await this.$get(this.$url.activity.elseActiveData, {
          currentPage: this.page,
          size: this.size,
          startTime: this.startTime,
          endTime: this.endTime,
          keyword: this.keyWord
        })
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.elseActiveContent = data.records
          this.totalNum = data.total
        } else {
          this.$message.error(msg)
        }
        // console.log(res.data)
      } catch (err) {
        console.log(err)
      }
    },

    // 按固定发文天数刷新数据
    refreshElseActiveData (key) {
      this.page = 1
      const date = new Date()
      switch (key) {
        case '2':
          this.startTime = this.getDate(-6) // 近7天
          this.endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
          this.getElseActiveData()
          break
        case '3':
          this.startTime = this.getDate(-29) // 近30天
          this.endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
          this.getElseActiveData()
          break
        case '4':
          this.startTime = this.getDate(-89) // 近90天
          this.endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
          this.getElseActiveData()
          break
        default:
          this.startTime = null
          this.endTime = null
          this.getElseActiveData()
          break
      }
    },

    // 自定义更新数据
    UpdateStartTime (start) {
      this.startTime = start
    },
    UpdateEndTime (end) {
      this.endTime = end
      this.getElseActiveData()
    },

    // 关键字查询
    keyWordRefer (kWord) {
      this.page = 1
      this.keyWord = kWord
      this.getElseActiveData()
    },

    // 重置
    resetElseActiveList () {
      this.startTime = null
      this.endTime = null
      this.keyWord = null
      this.getElseActiveData()
    },

    // 分页功能
    handleCurrentChange (page) {
      this.page = page
      this.getElseActiveData()
    }
  }
}
</script>

<style scoped lang="less">
.elseActive{
  width: 100%;
  min-height: 50vh;
  font-size: 16px;
  background-color: #F5F5F5;
  margin-top: 8px;
  overflow: hidden;
}
.elseActive-main{
  position: relative;
  width: 1230px;
  min-height: 50vh;
  background-color: #fff;
  box-sizing: border-box;
  margin: 20px auto 90px;
  padding: 28px 0;
  .elseActive-nav{
      width: 1200px;
      box-sizing: border-box;
      padding: 0 15px;
      /deep/.el-breadcrumb__inner{
        font-size: 16px;
        color: #000;
      }
      /deep/.is-link{
        font-size: 16px;
        font-weight: 500;
        color: #999 !important;
      }
      .content-num{
        font-size: 14px;
        color: #3056D9;
        margin: 20px 0;
      }
  }

}
.winning-project{
    width: 125px;
    font-size: 20px;
    font-weight: 600;
    padding-left: 15px;
    border-left: 5px solid #1076EC;
    border-radius: 2px 0 0 2px;
    margin-bottom: 20px;
}
</style>
